import { render, staticRenderFns } from "./InspectorImage.vue?vue&type=template&id=488e0157&scoped=true&"
import script from "./InspectorImage.vue?vue&type=script&setup=true&lang=js&"
export * from "./InspectorImage.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./InspectorImage.vue?vue&type=style&index=0&id=488e0157&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488e0157",
  null
  
)

export default component.exports